import { Pipe, PipeTransform } from '@angular/core';
import {
  ISbTariffEntryStory,
  ISbTariffSectionStory,
  TariffSize,
} from '../../../../../tariff';

@Pipe({
  name: 'filterTariffSectionForSize',
  standalone: true,
})
export class FilterTariffSectionForSizePipe implements PipeTransform {
  transform(
    sections: ISbTariffSectionStory[],
    size: TariffSize
  ): ISbTariffSectionStory[] {
    return this._filterEntries(sections, size);
  }

  private _filterEntries(
    sections: ISbTariffSectionStory[],
    size: TariffSize
  ): ISbTariffSectionStory[] {
    sections = sections.map((section) => {
      section = { ...section };
      switch (size) {
        case 'comfort':
          section.entries = this._filterComfort(section.entries);
          return section;
        case 'premium':
          section.entries = this._filterPremium(section.entries);
          return section;
        default:
          section.entries = this._filterBasic(section.entries);
          return section;
      }
    });
    return sections.filter((section) => (section.entries?.length || 0) > 0);
  }

  private _filterBasic(entries: ISbTariffEntryStory[]): ISbTariffEntryStory[] {
    return entries.filter(
      (entry) =>
        entry.tariffTypes.includes('basic') &&
        entry.tariffTypes.includes('comfort') &&
        entry.tariffTypes.includes('premium')
    );
  }
  private _filterComfort(
    entries: ISbTariffEntryStory[]
  ): ISbTariffEntryStory[] {
    return entries.filter(
      (entry) =>
        entry.tariffTypes.includes('comfort') &&
        entry.tariffTypes.includes('premium') &&
        !entry.tariffTypes.includes('basic')
    );
  }
  private _filterPremium(
    entries: ISbTariffEntryStory[]
  ): ISbTariffEntryStory[] {
    return entries.filter(
      (entry) =>
        entry.tariffTypes.includes('premium') &&
        !entry.tariffTypes.includes('basic') &&
        !entry.tariffTypes.includes('comfort')
    );
  }
}
